import { Face } from "@spi/Common/Geometry";

export class ConditionalGate {
    public faces: Face[];
    public gateReference: string;
}